export default __webpack_public_path__ + "static/media/example_zodiac.489a5c9b.png";